import type { Subscription } from '@brighterly/lib-core-types/subscription/interfaces'

import { SubscriptionStatus } from '@brighterly/lib-core-types/subscription/enums'

const ASSISTANT_STATUS_PRIORITY: SubscriptionStatus[] = [
  SubscriptionStatus.Ongoing,
  SubscriptionStatus.Paused,
  SubscriptionStatus.Retrying,
  SubscriptionStatus.Failed,
]

export const findDisciplineSubscription = (subscriptions: Subscription[], disciplineIds: number[]): Subscription | null => {
  const disciplineSubscriptions = subscriptions.filter(subscription =>
    subscription.disciplines.some(discipline => disciplineIds.includes(discipline.id)))

  return ASSISTANT_STATUS_PRIORITY
    .map(status => disciplineSubscriptions.find(subscription => subscription.status === status))
    .find(Boolean) ?? null
}
